const DAY_MS = 24 * 60 * 60 * 1000

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

// A card billing on the 31st bills on the 28th/30th in shorter months.
function billDateIn(year: number, month: number, billingDay: number): Date {
  const lastDay = new Date(year, month + 1, 0).getDate()
  return new Date(year, month, Math.min(billingDay, lastDay))
}

/** The next bill date on or after today, or null when the card has no billing day. */
export function nextBillDate(billingDay: number | null | undefined, today: Date): Date | null {
  if (!billingDay) return null
  const day = startOfDay(today)
  const thisMonth = billDateIn(day.getFullYear(), day.getMonth(), billingDay)
  return thisMonth >= day
    ? thisMonth
    : billDateIn(day.getFullYear(), day.getMonth() + 1, billingDay)
}

/** The current bill: the day after the previous bill date through the next one. */
export function billCycle(
  billingDay: number | null | undefined,
  today: Date
): { from: Date; to: Date } | null {
  const to = nextBillDate(billingDay, today)
  if (!to || !billingDay) return null
  const previous = billDateIn(to.getFullYear(), to.getMonth() - 1, billingDay)
  return {
    from: new Date(previous.getFullYear(), previous.getMonth(), previous.getDate() + 1),
    to,
  }
}

export function daysUntil(date: Date, today: Date): number {
  return Math.round((startOfDay(date).getTime() - startOfDay(today).getTime()) / DAY_MS)
}
